<template>

        <a @click="toogleActive"
           class="width-100 mb-xs mr-xs  text-danger"
           v-bind:class="{ 'btn btn-outline-danger' : isButton }"

        >
            <span v-if="!isFollow">
                <i class="fa"
                   v-bind:class="{ 'fa-heart-o' : !active , 'fa-heart': active }"/>
                <span v-if="count > 0">  <b> {{count}} </b> </span>
                 Like
            </span>

            <span v-if="isFollow">
                <i class="fa"
                   v-bind:class="{ 'fa-heart-o' : !active , 'fa-heart': active }"/>

                <span v-if="!active"> Follow </span>
                <span v-if="active"> Following </span>
            </span>
        </a>
</template>


<script>
  const fb        = require('@/firebaseConfig.js')
  const CommonLib = require('@/lib/Common')

  export default {
    name:       'Likes',
    components: {},
    props:      [
      'objectId',
      'userId',
      'follow',
      'type',
    ],
    data ()
    {
      return {
        active: false,
        count:  0,

        targetUser: null,
        isButton:   false,
        isFollow:   false,
      }
    },
    mounted ()
    {
      this.reload()
    },
    filters:    {},
    computed:   {
      docName ()
      {
        return this.$props.objectId + '_' + this.targetUser
      },
      countDocName ()
      {
        return '/computed/counts/' + this.$props.objectId
      },
      currentUserProfile ()
      {
        return this.$store.getters.currentUserProfile

      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },

    },
    methods:    {
      reload ()
      {
        var that = this
        if (!this.$props.userId)
        {
          this.targetUser = this.currentUser.uid
        }

        this.isFollow = this.$props.follow === true
        this.isButton = this.$props.type === 'button'

        fb.likesCollection.doc(this.docName).onSnapshot(function (doc) {

          that.active = doc.exists
        })

        fb.likesCollection.doc(this.countDocName).onSnapshot(function (doc) {

          if (!doc.exists || !doc.data().numberOfDocs)
          {
            that.count = 0
          } else
          {
            that.count = doc.data().numberOfDocs
          }
        })

      },
      toogleActive ()
      {
        var that = this

        if (this.active)
        {
          fb.likesCollection.doc(this.docName).delete().then(function (doc) {
            console.log(that.docName + ' Deleted')
          })

        } else
        {

          fb.likesCollection.doc(this.docName).set({
            createdOn: new Date(),
            updatedOn: new Date(),

            uid:      that.currentUser.uid,
            objectId: that.$props.objectId,
          }).then(function (doc) {
            console.log(that.docName + ' added')
          })
        }
      }
    },
    getters:    {
      getCount ()
      {
        return this.count
      },
    },
    watch:      {

      objectId: function (newval, oldVal) { this.reload()},
      userId:   function (newval, oldVal) { this.reload()},
      follow:   function (newval, oldVal) { this.reload()},
      type:     function (newval, oldVal) { this.reload()},

    },

  }

</script>

<style>


</style>
